(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(elements) {
    elements.forEach(function (el) {
      el.classList.add('scroll-reveal--visible');
    });
  }

  function init() {
    var elements = document.querySelectorAll('[data-scroll-reveal]:not(.scroll-reveal--visible)');
    if (!elements.length) return;

    elements.forEach(function (el) {
      var delay = el.getAttribute('data-scroll-reveal-delay');
      if (delay) el.style.setProperty('--scroll-reveal-delay', delay + 'ms');
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealAll(elements);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var scoped = e.target.querySelectorAll('[data-scroll-reveal]:not(.scroll-reveal--visible)');
    if (scoped.length) init();
  });
})();
